export default {
	base: {
		idicare: {
			slogan_1: "Tecnologias de Apoio à Saúde",
			slogan_2: "Preocupamo-nos com a sua saúde",
		},
		general: {
			dashboard: "Painel de controlo",
			// groups
			group: "Grupo",
			groups: "Grupos",
			// devices
			device: "Dispositivo",
			devices: "Dispositivos",
			// patients
			patient: "Paciente",
			patients: "Pacientes",
			no_patients: "Nenhum paciente",
			see_all_patients: "Ver todos os pacientes",
			next_appointment: "Próximo compromisso",
			next_birthday: "Próximo aniversário",
			// alerts
			alerts: "Alertas",
			no_alerts: "Sem alertas",
			see_all_alerts: "Ver todos os alertas",
			// user
			user_account: "Conta",
			// profile
			profile: "Perfil",
			user_profile: "Perfil de utilizador",
			your_profile: "O seu perfil",
			no_results: "Nenhum resultado encontrado",
			// tickets
			support: "Suporte",
			ticket: "Ticket",
			responses: "Respostas",
			new_ticket: "Abrir novo ticket",
			response: "Responder",
			close_ticket: "Fechar ticket",
			// Please select one report
			please_select: "Por favor, selecione um relatório",
			please_document: "Por favor selecione um documento",
			// Add
			add_picture: "Adicionar foto",
			//Warning msgs
			no_document: "Nenhum documento encontrado",

		},
		auth: {
			login: "Entrar",
			logout: "Sair",
			signup: "Inscrever-se",
			register: "Criar conta",
			already_registered: "Já tem uma conta?",
			no_account: "Não tem uma conta?",
			forgot_password: "Esqueceu a senha?",

			or: "ou",
			you_are_logged_out: "Você está desconectado",
			account_activation: "Activar conta",
			recover_password: "Recuperar senha",
			request_new_password: "Pedir nova senha",
			request: "Pedir",
			confirm: "Confirmar",
			back: "Voltar",
			msg_use_policy: "Confirmo que tenho 16 anos ou mais e concordo que o IDICARE processe meus dados pessoais para enviar material de marketing personalizado de acordo com o",
			msg_privacy_policy: "Pude ler e compreendo a informação sobre a utilização dos meus dados pessoais explicada na"
		},
		account: {
			change_account: "Mudar de conta",
			accounts: "Contas",
		},
		watch: {
			biometric: "Dados biométricos",
			geofencing: "GeoFencing",
			current_location: "Localização atual",
			pillbox: "Caixa de comprimidos",
			medication: "Medicação",
			no_medication_today: "Não há medicação para hoje",
			appointments: "Compromissos",
			no_appointments_today: "Não há compromissos para hoje",
			healthreports: "Relatórios de saúde",
			medicaldocs: "Documentos Médicos",
			profile: "Perfil do Paciente",
			chat: "Chat",
			personal_information: "Informação pessoal",
			timeline: "Linha Temporal",
			no_events: "Nenhum evento encontrado",
			calendar: "Calendário",
		},
		profile: {
			account_information: "Informação da conta",
			payment_methods: "Métodos de Pagamento",
			current_plan: "Plano atual",
			pro_plan: "Plano PRO",
			notifications: "Notificações",
			organizations: "Organizações",
			staff: "Funcionários",
			synchronization: "Sincronização",
			synchronization_interval: "Intervalo para sincronizar leituras, em segundos.",
			// account information
			information: "Informação",
			change_name: "Alterar nome",
			change_email: "Alterar email",
			change_password: "Alterar senha",
			change_picture: "Alterar imagem",
		}
	}
}



// WEBPACK FOOTER //
// ./src/i18n/base/base_pt.js